import Vue from 'vue';
import store from './../../store';
import billTransformer from './../../transformers/bill';

const success = ({ data }, resolve) => {
  const bill = billTransformer.fetch(data);
  store.dispatch('fetchCurrentBill', bill);

  resolve(bill);
};

const failed = (errors, reject) => {
  reject(errors);
};

export default id => (
  new Promise((resolve, reject) => {
    Vue.$http.post('credit_note', { id })
    .then((response) => {
      success(response.data, resolve);
    })
    .catch((errors) => {
      failed(errors, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/creditNote/store.js